/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchBigQueryAccessTokenForSuccessViewMutationVariables =
  Types.Exact<{
    code: Types.Scalars["String"]["input"];
    state: Types.Scalars["String"]["input"];
  }>;

export type FetchBigQueryAccessTokenForSuccessViewMutation = {
  readonly __typename: "Mutation";
  readonly fetchBigQueryAccessToken: {
    readonly __typename: "BigQueryOAuthConnection";
    readonly id: c.BigQueryOAuthConnectionId;
    readonly accessTokenExpires: c.DateTimeString | null;
    readonly linkedDataConnections: ReadonlyArray<{
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    }>;
  };
};

export const FetchBigQueryAccessTokenForSuccessViewDocument = /*#__PURE__*/ gql`
  mutation FetchBigQueryAccessTokenForSuccessView(
    $code: String!
    $state: String!
  ) {
    fetchBigQueryAccessToken(code: $code, state: $state) {
      id
      accessTokenExpires
      linkedDataConnections {
        id
      }
    }
  }
`;
export type FetchBigQueryAccessTokenForSuccessViewMutationFn =
  Apollo.MutationFunction<
    FetchBigQueryAccessTokenForSuccessViewMutation,
    FetchBigQueryAccessTokenForSuccessViewMutationVariables
  >;

/**
 * __useFetchBigQueryAccessTokenForSuccessView__
 *
 * To run a mutation, you first call `useFetchBigQueryAccessTokenForSuccessView` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchBigQueryAccessTokenForSuccessView` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchBigQueryAccessTokenForSuccessView, { data, loading, error }] = useFetchBigQueryAccessTokenForSuccessView({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFetchBigQueryAccessTokenForSuccessView(
  baseOptions?: Apollo.MutationHookOptions<
    FetchBigQueryAccessTokenForSuccessViewMutation,
    FetchBigQueryAccessTokenForSuccessViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FetchBigQueryAccessTokenForSuccessViewMutation,
    FetchBigQueryAccessTokenForSuccessViewMutationVariables
  >(FetchBigQueryAccessTokenForSuccessViewDocument, options);
}
export type FetchBigQueryAccessTokenForSuccessViewHookResult = ReturnType<
  typeof useFetchBigQueryAccessTokenForSuccessView
>;
export type FetchBigQueryAccessTokenForSuccessViewMutationResult =
  Apollo.MutationResult<FetchBigQueryAccessTokenForSuccessViewMutation>;
export type FetchBigQueryAccessTokenForSuccessViewMutationOptions =
  Apollo.BaseMutationOptions<
    FetchBigQueryAccessTokenForSuccessViewMutation,
    FetchBigQueryAccessTokenForSuccessViewMutationVariables
  >;
